//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosGet } from '../../../axios/axios.js'
import ReportMaterialsAvailable from './ReportMaterialsAvailable.vue'
import ReportMaterialsConsuming from './ReportMaterialsConsuming.vue'
import ReportContentSection from '../ReportContent/ReportContentSection.vue'

export default {
  components: {
    ReportMaterialsConsuming: ReportMaterialsConsuming,
    ReportMaterialsAvailable: ReportMaterialsAvailable,
    ReportContentSection
  },
  props: {
    reportId: {
      type: Number,
      default: null
    },
    reportName: {
      type: String,
      default: null
    },
    reports: {
      type: Array,
      default () {
        return null
      }
    },
    checking: {
      type: Boolean,
      default: false
    },
    reportRoles: {
      type: Object,
      default () {
        return {}
      }
    },
    serviceObject: {
      type: Object,
      default () {
        return {}
      }
    },
    report: {
      type: Object,
      default () {
        return {}
      }
    },
    request: {
      type: Object,
      default () {
        return null
      }
    }
  },
  data: function () {
    return {
      materialesAvailable: [],
      demountings: [],
      mountings: [],
      debits: [],
      consumptions: [],

      materialsCollapse: [],
      materialsgroupCollapse: {},
      materialsAvailableOpen: false
    }
  },
  computed: {
    reportActionsAccess: function () {
      return this.report.actionsAccess ? this.report.actionsAccess : {}
    },
    mobile: function () {
      return this.$store.getters.getUser.view === 'mobile'
    }
  },
  created: function () {
    this.getMaterialsAvailable()
    if (this.report.reports && this.report.reports.length) {
      this.report.reports.forEach((report) => {
        this.$set(this.materialsgroupCollapse, report.id, false)
      })
    }
  },
  methods: {
    onCollapse: function (index, reportId) {
      if (this.materialsgroupCollapse[reportId] !== undefined) {
        this.materialsgroupCollapse[reportId] = true
      }
      if (this.materialsCollapse.indexOf(index + 1) === -1) {
        this.materialsCollapse.push(index + 1)
      }
      this.$emit('default-opened-collapse-materials')
    },
    onChangeMaterialesAvailable: function (materialesAvailable) {
      this.materialesAvailable = [...materialesAvailable]
    },
    getMaterialsAvailable: function () {
      axiosGet({
        url: '/service/delta/report/' + this.reportId + '/stocktools',
        onSuccess: (response) => {
          this.materialesAvailable = response.data.result
        },
        onFailure: 'Ошибка получения доступных материалов',
        msgTarget: this
      })
    }
  }
}

